export default __webpack_public_path__ + "static/media/Glove of the Swift Talon.13aaf6c2.jpg";